import moment from "moment";
import React, { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner, Table } from "reactstrap";
import { QRCodeSVG } from "qrcode.react";

export const ButtonPrintF4 = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

const cellStyle = {
  border: "1px solid black",
  padding: "4px",
  height: "14px",
  textAlign: "center",
  verticalAlign: "top",
  wordWrap: "break-word",
};

export const PrintDocF4 = ({ innerRef, item, type }) => {
  console.log(item);
  const validValue = (val) => {
    return <span className="courier-prime-bold text-capitalize">{`${val || "..................."}`}</span>;
  };

  const validValue2 = (val) => {
    return <span className="courier-prime-bold text-capitalize">{`${val || "......................................................"}`}</span>;
  };

  const handleValidDate = (date) => {
    return moment(date).format("D MMMM YYYY");
  };
  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }
  // const svgElement = document.querySelector('#qrcode-container svg');
  // const svgString = new XMLSerializer().serializeToString(svgElement);
  // const base64Svg = `data:image/svg+xml;base64,${btoa(svgString)}`;

  return !item || item === undefined || item === null ? (
    <div></div>
  ) : (
    <div
      // className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      {/* ///1/// */}
      {type === "f4-surat-pernyataan-tidak-sengketa" && (

        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div
            style={{
              textAlign: "center",
              padding: "5px 0",
              textDecoration: "underline",
              fontSize: "18px",
              fontWeight: "bold",
            }}>SURAT PERNYATAAN TIDAK SENGKETA
          </div>
          <div style={{ padding: "10px" }}>
            <span>Yang bertanda-tangan di bawah ini : </span>
            <table style={{ marginLeft: "40px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.2" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                  <td style={{ width: "15px", verticalAlign: "top" }}>:</td>
                  <td> {validValue(item?.legal_nominatif?.nama)}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "120px" }}>Tempat / Tgl.lahir</td>
                  <td style={{ width: "15px", verticalAlign: "top" }}>:</td>
                  <td> {validValue(item.legal_nominatif?.tempat_lahir)}/ {validValue(item.legal_nominatif?.tgl_lahir && item.legal_nominatif?.tgl_lahir !== "" && handleValidDate(item.legal_nominatif?.tgl_lahir))}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "120px" }}>Pekerjaan</td>
                  <td style={{ width: "15px", verticalAlign: "top" }}>:</td>
                  <td> {validValue(item?.legal_nominatif?.pekerjaan && item?.legal_nominatif?.pekerjaan)}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "120px" }}>K.T.P No</td>
                  <td style={{ width: "15px", verticalAlign: "top" }}>:</td>
                  <td> {validValue(item?.legal_nominatif?.ktp)}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "120px" }}>Alamat</td>
                  <td style={{ width: "15px", verticalAlign: "top" }}>:</td>
                  <td> {validValue(item?.legal_nominatif?.alamat_1)}</td>
                </tr>
              </tbody>
            </table>
            <div
              style={{
                marginTop: "10px",
              }}>
              <div>
                <div style={{ display: "flex", alignItems: "end" }}>
                  <span style={{ whiteSpace: "nowrap", flexShrink: 0 }}>Dengan itikad baik dan sanggup diangkat sumpah menyatakan dengan&nbsp;:</span>
                </div>
                <div style={{ display: "flex", alignItems: "end" }}>
                  <span style={{ whiteSpace: "nowrap", flexShrink: 0 }}>Yaitu sebagai berikut&nbsp;:</span>
                </div>
              </div>
              <table
                style={{
                  marginLeft: "25px",
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                  lineHeight: "1.2",
                }}>
                <tbody>
                  <tr>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>1. </td>
                    <td style={{ verticalAlign: "top" }}>
                      Bahwa saya adalah pemilik/kuasa atas bidang tanah sawah/darat yang terletak di&nbsp;: &nbsp;{validValue(item?.legal_nominatif?.letak_tanah)}&nbsp;, RT &nbsp;{validValue(item?.legal_nominatif?.rt)}&nbsp; / RW &nbsp;{validValue(item?.legal_nominatif?.rw)}&nbsp;, Desa &nbsp;{validValue(item?.legal_nominatif?.desa)}&nbsp;, Kecamatan &nbsp;{validValue(item?.legal_nominatif?.kecamatan)}, &nbsp; Kabupaten Bogor, Seluas ± &nbsp;
                      {validValue(currencyFormat(item?.legal_nominatif?.luas_tanah))} &nbsp;M² (lebih kurang &nbsp;{validValue(item?.legal_nominatif?.terbilang_luas_tanah)})
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>2.</td>
                    <td style={{ verticalAlign: "top" }}>
                      Adapun tanah tersebut terdaftar dalam buku induk desa dengan Girik/leter C No &nbsp;{validValue(item?.legal_nominatif?.no_c)}&nbsp; Persil No &nbsp;{validValue(item?.legal_nominatif?.no_persil)}&nbsp;, Kelas &nbsp;{validValue(item?.legal_nominatif?.kelas_desa)}&nbsp;, SPPT. No &nbsp;{validValue(item?.legal_nominatif?.nop)}&nbsp; Dengan batas-batas yaitu sebagai berikut&nbsp;:
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                style={{
                  marginLeft: "40px",
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                  lineHeight: "1.2",
                }}>
                <tbody>
                  <tr>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>-</td>
                    <td style={{ verticalAlign: "top" }}>Sebelah Utara</td>
                    <td style={{ padding: "2px 4px", verticalAlign: "top" }}>: {validValue(item?.legal_nominatif?.utara)}</td>
                    <td>{""}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>-</td>
                    <td style={{ verticalAlign: "top" }}>Sebelah Timur</td>
                    <td style={{ padding: "2px 4px", verticalAlign: "top" }}>: {validValue(item?.legal_nominatif?.timur)}</td>
                    <td>{""}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>-</td>
                    <td style={{ verticalAlign: "top" }}>Sebelah Selatan</td>
                    <td style={{ padding: "2px 4px", verticalAlign: "top" }}>: {validValue(item?.legal_nominatif?.selatan)}</td>
                    <td>{""}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>-</td>
                    <td style={{ verticalAlign: "top" }}>Sebelah Barat</td>
                    <td style={{ padding: "2px 4px", verticalAlign: "top" }}>: {validValue(item?.legal_nominatif?.barat)}</td>
                    <td>{""}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              style={{
                marginTop: "10px",
              }}>
              <span>Bahwa saya menjamin, keadaan tanah tersebut adalah sebagai berikut : </span>
              <table style={{ marginLeft: "25px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.2" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "15px", verticalAlign: "top" }}>1.</td>
                    <td style={{ padding: "2px 4px", verticalAlign: "top" }}>Tidak dalam sengketa, baik hak maupun batas-batasnya.</td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", verticalAlign: "top" }}>2.</td>
                    <td style={{ padding: "2px 4px", verticalAlign: "top" }}>Tidak sedang dijaminkan kepada Bank Pemerintah/Swasta.</td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", verticalAlign: "top" }}>3.</td>
                    <td style={{ padding: "2px 4px", verticalAlign: "top" }}>Tidak sedang digadaikan kepada pihak lain.</td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", verticalAlign: "top" }}>4.</td>
                    <td style={{ padding: "2px 4px", verticalAlign: "top" }}>Telah melunasi PBB/SPPT tahun berjalan</td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", verticalAlign: "top" }}>5.</td>
                    <td style={{ padding: "2px 4px", verticalAlign: "top" }}>Tidak merupakan tanah negara, tanah kehutanan, tanah khas desa, atau tanah yang Statusnya tidak jelas</td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", verticalAlign: "top" }}>6.</td>
                    <td style={{ padding: "2px 4px", verticalAlign: "top" }}>Tidak bersertifikat/atau belum pernah dimohonkan sertifikatnya kepada instansi Badan Pertanahan Nasional (BPN) yang berwenang</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              style={{
                marginTop: "10px",
              }}>
              <p>Demikian surat pernyataan ini di buat dengan sebenarnya, dalam keadaan sehat wal’afiat tanpa paksaan dari pihak manapun juga dan apabila pernyataan ini tidak benar, SAYA SANGGUP DITUNTUT DIHADAPAN PIHAK-PIHAK YANG BERWENANG SESUAI DENGAN KETENTUAN-KETENTUAN YANG BERLAKU</p>
            </div>
            {/* // */}

            <div
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "start",
                justifyContent: "space-between",
              }}>
              <div>
                <p>Saksi-Saksi :</p>
                <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.2" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "15px", verticalAlign: "top" }}>1.</td>
                      <td style={{ padding: "2px 4px", verticalAlign: "top" }}>.........................................................({validValue(item?.legal_nominatif?.ketua_rt)})</td>
                    </tr>
                    <tr>
                      <td style={{ width: "15px", verticalAlign: "top" }}></td>
                      <td style={{ padding: "70px 4px 30px 4px", verticalAlign: "top" }}>Ketua RT &nbsp;{validValue(item?.legal_nominatif?.rt)} &nbsp;</td>
                    </tr>
                    <tr>
                      <td style={{ width: "15px", verticalAlign: "top" }}>2.</td>
                      <td style={{ padding: "2px 4px", verticalAlign: "top" }}>.........................................................({validValue(item?.legal_nominatif?.ketua_rw)})</td>
                    </tr>
                    <tr>
                      <td style={{ width: "15px", verticalAlign: "top" }}></td>
                      <td style={{ padding: "70px 4px 30px 4px", verticalAlign: "top" }}>Ketua RW &nbsp;{validValue(item?.legal_nominatif?.rw)} &nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                style={{
                  width: "250px",
                  textAlign: "center",
                }}>
                <div>Bogor tgl, &nbsp;{validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")}&nbsp;
                </div>
                <div>Saya yang menyatakan </div>
                <div
                  style={{
                    marginTop: "110px",
                    fontWeight: "bold",
                  }}></div>
                <div
                  style={{
                    marginTop: "80px",
                  }}>
                  {validValue(item?.legal_nominatif?.nama)}
                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
              }}>
              <div
                style={{
                  width: "300px",
                  textAlign: "center",
                }}>
                <div style={{ marginBottom: "10px" }}>Mengetahui :</div>
                <div
                  style={{
                    display: "flex",
                  }}>
                  <table
                    style={{
                      borderCollapse: "collapse",
                      tableLayout: "fixed",
                      textAlign: "left",
                      lineHeight: "1.2",
                    }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>-</td>
                        <td style={{ verticalAlign: "top", width: "150px" }}>Kepala Desa</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>{validValue(item?.legal_nominatif?.desa)}</td>
                      </tr>
                      <tr>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>-</td>
                        <td style={{ verticalAlign: "top" }}>Tanggal</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>{validValue(null)}</td>
                      </tr>
                      <tr>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>-</td>
                        <td style={{ verticalAlign: "top" }}>Reg. No</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>{validValue(item?.legal_nominatif?.tidak_tahu)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    marginTop: "80px",
                    fontWeight: "bold",
                  }}></div>
                <div
                  style={{
                    marginTop: "80px",
                  }}>
                  {validValue(item?.legal_nominatif?.kepala_desa)}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ///2/// */}
      {type === "f4-surat-pernyataan-menghadap" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline", fontSize: "20px", marginBottom: "20px" }}>SURAT PERNYATAAN MENGHADAP</div>
          <div>Yang bertanda tangan di bawah ini</div>
          <div style={{ marginTop: "10px" }}>
            <table style={{ borderCollapse: "collapse", lineHeight: "1.8" }}>
              <tbody>
                <tr>
                  <td style={{ width: "20px" }}>I.</td>
                  <td style={{ width: "80px" }}>Nama</td>
                  <td style={{ width: "20px" }}>:</td>
                  <td>{validValue(item?.legal_nominatif?.nama)}</td>
                </tr>
                <tr>
                  <td style={{ width: "20px" }}></td>
                  <td>Umur</td>
                  <td style={{ width: "20px" }}>:</td>
                  <td>{validValue(item?.legal_nominatif?.usia ? item?.legal_nominatif?.usia + " TAHUN" : "......... TAHUN")}</td>
                </tr>
                <tr>
                  <td style={{ width: "20px" }}></td>
                  <td>Pekerjaan</td>
                  <td style={{ width: "20px" }}>:</td>
                  <td>{validValue(item?.legal_nominatif?.pekerjaan && item?.legal_nominatif?.pekerjaan)}</td>
                </tr>
                <tr>
                  <td style={{ width: "20px" }}></td>
                  <td>Alamat</td>
                  <td style={{ width: "20px" }}>:</td>
                  <td>{validValue(item?.legal_nominatif?.alamat_1)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "10px" }}>Dalam hal ini disebut pihak pertama</div>
          <table style={{ borderCollapse: "collapse", lineHeight: "1.8", marginTop: "10px" }}>
            <tbody>
              <tr>
                <td style={{ width: "20px" }}>II.</td>
                <td style={{ width: "80px" }}>Nama</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.nama_2)}</td>
              </tr>
              <tr>
                <td style={{ width: "20px" }}></td>
                <td>Umur</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.usia_2 ? item?.legal_nominatif?.usia_2 + " TAHUN" : "......... TAHUN")}</td>
              </tr>
              <tr>
                <td style={{ width: "20px" }}></td>
                <td>Pekerjaan</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.pekerjaan_2)}</td>
              </tr>
              <tr>
                <td style={{ width: "20px" }}></td>
                <td>Aalamat</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.alamat_2)}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginTop: "10px" }}>Dalam hal ini disebut pihak kedua.</div>
          <p style={{ textAlign: "justify", marginTop: "20px", lineHeight: "1.8" }}>
            Pada hari ini &nbsp;{validValue(item?.legal_nominatif?.tidak_tahu)} &nbsp;tanggal &nbsp;{validValue(item?.legal_nominatif?.tidak_tahu)} &nbsp;. telah menghadap kepada camat selaku PPAT untuk menandatangani AKTA JUAL BELI sebidang tanah milik ada SPPT No. &nbsp;{validValue(item?.legal_nominatif?.nop)} &nbsp;. Persil No. &nbsp;{validValue(item?.legal_nominatif?.no_persil)} &nbsp;. Luas &nbsp;{validValue(item?.legal_nominatif?.luas_tanah)}
            &nbsp;. C. Desa No &nbsp;{validValue(item?.legal_nominatif?.no_c)} &nbsp;tercatat atas nama &nbsp;{validValue(item?.legal_nominatif?.nama)} &nbsp;. terletak blok &nbsp;{validValue(item?.legal_nominatif?.blok ?? "")} &nbsp;. Desa &nbsp;{validValue(item?.legal_nominatif?.desa)} &nbsp;. Kecamatan &nbsp;{validValue(item?.legal_nominatif?.kecamatan)}, Kabupaten Bogor.
          </p>
          <p style={{ textAlign: "center", marginTop: "20px" }}>Demikian Surat pernyataan ini kami buat dengan sebenarnya</p>
          <div style={{ marginTop: "40px", display: "flex", justifyContent: "space-between" }}>
            <div></div>
            <div>
              <div>
                &nbsp;{validValue(item?.legal_nominatif?.tempat)}, &nbsp;{validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")} &nbsp;
              </div>
              <div style={{ height: "60px" }}></div>
              <div>1. &nbsp;{validValue(item?.legal_nominatif?.nama)} &nbsp;(.........................................................)</div>
              <div style={{ paddingTop: "60px" }}>2. &nbsp;{validValue(item?.legal_nominatif?.nama_2)} &nbsp;(.........................................................)</div>
            </div>
          </div>
          <div style={{ marginTop: "40px", fontWeight: "bold", textTransform: "capitalize" }}>Saksi-Saksi</div>
          <table style={{ borderCollapse: "collapse", lineHeight: "2", marginTop: "10px" }}>
            <tbody>
              <tr>
                <td style={{ width: "20px", paddingTop: "25px" }}>1.</td>
                <td style={{ width: "120px", paddingTop: "25px" }}>{validValue(item?.legal_nominatif?.kepala_desa)}</td>
                <td style={{ width: "100px", paddingTop: "25px" }}>Kepala Desa</td>
                <td style={{ paddingTop: "25px" }}>: .........................................................</td>
              </tr>
              <tr>
                <td style={{ width: "20px", paddingTop: "25px" }}>2.</td>
                <td style={{ width: "120px", paddingTop: "25px" }}>{validValue(item?.legal_nominatif?.sekdes)}</td>
                <td style={{ width: "100px", paddingTop: "25px" }}>Sekdes</td>
                <td style={{ paddingTop: "25px" }}>: .........................................................</td>
              </tr>
              <tr>
                <td style={{ width: "20px", paddingTop: "25px" }}>3.</td>
                <td style={{ width: "120px", paddingTop: "25px" }}>{validValue(item?.legal_nominatif?.kadus)}</td>
                <td style={{ width: "100px", paddingTop: "25px" }}>Kepala Dusun</td>
                <td style={{ paddingTop: "25px" }}>: .........................................................</td>
              </tr>
              <tr>
                <td style={{ width: "20px", paddingTop: "25px" }}>4.</td>
                <td style={{ width: "120px", paddingTop: "25px" }}>{validValue(item?.legal_nominatif?.ketua_rw)}</td>
                <td style={{ width: "100px", paddingTop: "25px" }}>Ketua RW</td>
                <td style={{ paddingTop: "25px" }}>: .........................................................</td>
              </tr>
              <tr>
                <td style={{ width: "20px", paddingTop: "25px" }}>5.</td>
                <td style={{ width: "120px", paddingTop: "25px" }}>{validValue(item?.legal_nominatif?.ketua_rt)}</td>
                <td style={{ width: "100px", paddingTop: "25px" }}>Ketua RT</td>
                <td style={{ paddingTop: "25px" }}>: .........................................................</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {/* ///3/// */}
      {type === "f4-surat-keterangan-status-tanah" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div>
            <div style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline", fontSize: "20px", marginBottom: "5px" }}>SURAT KETERANGAN STATUS TANAH</div>
            <div style={{ textAlign: "center", marginBottom: "50px" }}>Nomor: ........................................................ / ........................................................</div>

            <p style={{ lineHeight: "1.8", textAlign: "justify" }}>
              Yang bertanda tangan dibawah ini Kepala Desa &nbsp;{validValue(item?.legal_nominatif?.kepala_desa)} &nbsp;Kecamatan &nbsp;{validValue(item?.legal_nominatif?.kecamatan)} &nbsp;Kabupaten Bogor, dengan ini menerangkan bahwa menurut data pada kantor kami dan menurut sepengetahuan saya, tanah yang tercantum dalam buku induk ( ) C Nomor &nbsp;{validValue(item?.legal_nominatif?.no_c)} &nbsp;Persil No. &nbsp;{validValue(item?.legal_nominatif?.no_persil)} &nbsp;SPPT No. &nbsp;
              {validValue(item?.legal_nominatif?.nop)} &nbsp;Luas Tanah &nbsp;{validValue(item?.legal_nominatif?.luas_tanah)} &nbsp;M², Blok &nbsp;{validValue(item?.legal_nominatif?.blok ?? "")} &nbsp;Desa &nbsp;{validValue(item?.legal_nominatif?.desa)} &nbsp;Kecamatan &nbsp;{validValue(item?.legal_nominatif?.kecamatan)} &nbsp;Kabupaten Bogor.
            </p>

            <div style={{ marginTop: "20px" }}>Dengan Batas-batas sebagai berikut :</div>

            <table style={{ borderCollapse: "collapse", marginTop: "10px" }}>
              <tbody>
                <tr>
                  <td style={{ width: "150px" }}>Sebelah Utara</td>
                  <td>: {validValue(item?.legal_nominatif?.utara)}</td>
                </tr>
                <tr>
                  <td>Sebelah Timur</td>
                  <td>: {validValue(item?.legal_nominatif?.timur)}</td>
                </tr>
                <tr>
                  <td>Sebelah Selatan</td>
                  <td>: {validValue(item?.legal_nominatif?.selatan)}</td>
                </tr>
                <tr>
                  <td>Sebelah Barat</td>
                  <td>: {validValue(item?.legal_nominatif?.barat)}</td>
                </tr>
              </tbody>
            </table>
            <p style={{ textAlign: "justify", marginTop: "20px", lineHeight: "1.8" }}>Tanah tersebut adalah tanah milik adat, bukan tanah milik negara, kehutanan, atau tanah-tanah yang statusnya tidak jelas.</p>
            <p style={{ textAlign: "justify", marginTop: "10px" }}>Demikian Surat pernyataan ini kami buat dengan sebenarnya dan untuk dipergunakan sebagaimana mestinya.</p>
            <div style={{ marginTop: "40px", textAlign: "center", width: "300px", float: "right" }}>
              <div>
                {validValue(item?.legal_nominatif?.tempat)}, {validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")}.
              </div>
              Kepala Desa
              <div style={{ marginTop: "80px" }}>{validValue(item?.legal_nominatif?.kepala_desa)}</div>
            </div>
          </div>
        </div>
      )}
      {/* ///4/// */}
      {type === "f4-surat-keterangan-riwayat-tanah" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "80px 80px 80px 80px", fontSize: "12px" }}>
          <div style={{ marginBottom: "20px" }}>
            <table style={{ borderCollapse: "collapse", lineHeight: "1.8", marginTop: "10px" }}>
              <tbody>
                <tr>
                  <td style={{ width: "150px" }}>PEMERINTAH DESA</td>
                  <td>: {validValue(item?.legal_nominatif?.desa)}</td>
                </tr>
                <tr>
                  <td>KECAMATAN</td>
                  <td>: {validValue(item?.legal_nominatif?.kecamatan)}</td>
                </tr>
                <tr>
                  <td>KABUPATEN/ KOTA</td>
                  <td>: BOGOR</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline", fontSize: "20px", marginBottom: "8px" }}>SURAT KETERANGAN RIWAYAT TANAH</div>

          <div style={{ marginBottom: "40px", display: "flex", justifyContent: "center" }}>
            <span style={{ width: "380px" }}> Nomor : </span>
          </div>

          <p style={{ textAlign: "justify" }}>
            Kami yang bertanda tangan dibawah ini, Kepala Desa &nbsp;{validValue(item?.legal_nominatif?.kepala_desa)}, Kecamatan &nbsp;{validValue(item?.legal_nominatif?.kecamatan)}, Kabupaten Bogor, dengan ini menerangkan dengan sebenarnya bahwa tanah yang dimiliki oleh &nbsp;{validValue(item?.legal_nominatif?.nama)}, Seluas ± &nbsp;{validValue(item?.legal_nominatif?.luas_tanah)} M², adalah betul-betul merupakan tanah milik adat.
          </p>

          <p style={{ textAlign: "justify" }}>
            Adapun tanah tersebut, tercatat pada C. Desa No &nbsp;{validValue(item?.legal_nominatif?.no_c)} &nbsp;Persil &nbsp;{validValue(item?.legal_nominatif?.no_persil)} &nbsp;Klas. &nbsp;{validValue(item?.legal_nominatif?.kelas_desa)}, Desa &nbsp;{validValue(item?.legal_nominatif?.desa)}, Kecamatan &nbsp;{validValue(item?.legal_nominatif?.kecamatan)}, Kabupaten Bogor.
          </p>

          <p style={{ textAlign: "justify" }}>Dengan Batas - batas sebagai berikut :</p>
          <div style={{ marginBottom: "10px", fontWeight: "bold", textTransform: "capitalize" }}>
            <tbody>
              <tr>
                <td style={{ width: "80px" }}>UTARA</td>
                <td>: &nbsp;{validValue(item?.legal_nominatif?.utara)} &nbsp;</td>
              </tr>
              <tr>
                <td>TIMUR</td>
                <td>: &nbsp;{validValue(item?.legal_nominatif?.timur)} &nbsp;</td>
              </tr>
              <tr>
                <td>SELATAN</td>
                <td>: &nbsp;{validValue(item?.legal_nominatif?.selatan)} &nbsp;</td>
              </tr>
              <tr>
                <td>BARAT</td>
                <td>: &nbsp;{validValue(item?.legal_nominatif?.barat)} &nbsp;</td>
              </tr>
            </tbody>
          </div>

          <p>Dan menurut catatan di Kantor kami, Riwayat tanah tersebut adalah sebagai berikut :</p>
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", paddingRight: "10px", width: "30px" }}>1.</td>
                <td>
                  Tahun &nbsp;{validValue(item?.legal_nominatif?.tahun_1)} &nbsp;atas nama &nbsp;{validValue(item?.legal_nominatif?.ats_nama_1)}, tercatat dalam &nbsp;{validValue(item?.legal_nominatif?.berdasarkan_1)} &nbsp;
                </td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", paddingRight: "10px", width: "30px" }}>2.</td>
                <td>
                  Tahun &nbsp;{validValue(item?.legal_nominatif?.tahun_2)} &nbsp;Beralih Kepada &nbsp;{validValue(item?.legal_nominatif?.beralih_kepada_2)}, Berdasarkan. &nbsp;{validValue(item?.legal_nominatif?.berdasarkan_2)} &nbsp;
                </td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", paddingRight: "10px", width: "30px" }}>3.</td>
                <td>
                  Tahun &nbsp;{validValue(item?.legal_nominatif?.tahun_3)} &nbsp;Beralih Kepada &nbsp;{validValue(item?.legal_nominatif?.beralih_kepada_3)}, Berdasarkan. &nbsp;{validValue(item?.legal_nominatif?.berdasarkan_3)} &nbsp;
                </td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", paddingRight: "10px", width: "30px" }}>4.</td>
                <td>
                  Tahun &nbsp;{validValue(item?.legal_nominatif?.tahun_4)} &nbsp;Beralih Kepada &nbsp;{validValue(item?.legal_nominatif?.beralih_kepada_4)}, Berdasarkan. &nbsp;{validValue(item?.legal_nominatif?.berdasarkan_4)} &nbsp;
                </td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", paddingRight: "10px", width: "30px" }}>5.</td>
                <td>
                  Tahun &nbsp;{validValue(item?.legal_nominatif?.tahun_5)} &nbsp;Beralih Kepada &nbsp;{validValue(item?.legal_nominatif?.beralih_kepada_5)}, Berdasarkan. &nbsp;{validValue(item?.legal_nominatif?.berdasarkan_5)} &nbsp;
                </td>
              </tr>
            </tbody>
          </table>

          <p>
            Kemudian perlu kami jelaskan pula, bahwa tanah tersebut <strong style={{ textDecoration: "underline" }}>TIDAK DALAM SENGKETA</strong> baik pemiliknya maupun batas - batasnya, dan juga sampai saat ini belum mempunyai
          </p>

          <p>
            <strong>SERTIFIKAT/SERTIFIKAT SEMENTARA</strong>
          </p>

          <p>Demikian Surat keterangan ini kami buat dengan sebenarnya dan apabila surat keterangan ini tidak benar, kami bersedia dituntut sesuai hukum yang berlaku</p>

          <div style={{ marginTop: "40px", textAlign: "center", width: "300px", float: "right" }}>
            <div>
              {validValue(item?.legal_nominatif?.tempat)}, {validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")}.
            </div>
            Kepala Desa
            <div style={{ marginTop: "80px" }}>{validValue(item?.legal_nominatif?.kepala_desa)}</div>
          </div>
        </div>
      )}
      {/* ///5/// */}
      {type === "f4-surat-pernyataan-menjual" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline", fontSize: "20px", marginBottom: "40px" }}>SURAT PERNYATAAN MENJUAL</div>

          <p>Yang bertanda tangan dibawah ini :</p>

          <table style={{ marginBottom: "16px" }}>
            <tbody>
              <tr>
                <td style={{ width: "80px" }}>Nama</td>
                <td>: {validValue(item?.legal_nominatif?.nama)}</td>
              </tr>
              <tr>
                <td>Umur</td>
                <td>: {validValue(item?.legal_nominatif?.usia ? item?.legal_nominatif?.usia + " TAHUN" : "......... TAHUN")}</td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td>: {validValue(item?.legal_nominatif?.pekerjaan && item?.legal_nominatif?.pekerjaan)}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td>: {validValue(item?.legal_nominatif?.alamat_1)}</td>
              </tr>
            </tbody>
          </table>

          <p>
            Menyatakan dengan sesungguhnya, bahwa tanah milik saya diatas persil No. &nbsp;{validValue(item?.legal_nominatif?.no_persil)} &nbsp;No. C Desa &nbsp;{validValue(item?.legal_nominatif?.no_c)}, SPPT NO &nbsp;{validValue(item?.legal_nominatif?.nop)}, Luas Tanah &nbsp;{validValue(currencyFormat(item?.legal_nominatif?.luas_tanah))} &nbsp;M² dengan harga Rp. &nbsp;{validValue(currencyFormat(item?.legal_nominatif?.harga))} &nbsp; ({validValue(item?.legal_nominatif?.terbilang_harga)} ). Yang
            terletak di Blok &nbsp;{validValue(item?.legal_nominatif?.blok ?? "")} &nbsp;Desa &nbsp;{validValue(item?.legal_nominatif?.desa)} &nbsp;Kecamatan &nbsp;{validValue(item?.legal_nominatif?.kecamatan)}, Kabupaten Bogor.
          </p>

          <p>
            <em>
              <strong>Benar-benar saya nyatakan Untuk di jual.</strong>
            </em>
          </p>

          <p>Dengan Batas - batas sebagai berikut :</p>
          <table style={{ marginBottom: "16px" }}>
            <tbody>
              <tr>
                <td style={{ width: "80px" }}>Utara</td>
                <td>: &nbsp;{validValue(item?.legal_nominatif?.utara)} &nbsp;</td>
              </tr>
              <tr>
                <td>Timur</td>
                <td>: &nbsp;{validValue(item?.legal_nominatif?.timur)} &nbsp;</td>
              </tr>
              <tr>
                <td>Selatan</td>
                <td>: &nbsp;{validValue(item?.legal_nominatif?.selatan)} &nbsp;</td>
              </tr>
              <tr>
                <td>Barat</td>
                <td>: &nbsp;{validValue(item?.legal_nominatif?.barat)} &nbsp;</td>
              </tr>
            </tbody>
          </table>

          <span>Adapun keadaan tanah sebagai berikut :</span>
          <ol type="a">
            <li>Tanah tersebut berstatus Hak Milik Adat ;</li>
            <li>Tanah tersebut tidak dalam keadaan sengketa ;</li>
            <li>Tanah tersebut belum pernah dijadikan jaminan hutang piutang / jual belikan</li>
          </ol>

          <p>Demikian Surat pernyataan ini saya buat dalam keadaan sehat jasmani dan rohani serta tidak ada unsur paksaan dari pihak manapun.</p>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}><div>
              <tbody>
                <tr>
                  <td style={{ width: "55px" }}>Nomor</td>
                  <td>: &nbsp;{validValue(item?.legal_nominatif?.tidak_tahu)} &nbsp;.</td>
                </tr>
                <tr>
                  <td>Tanggal</td>
                  <td>: &nbsp;{validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")} &nbsp;.</td>
                </tr>
              </tbody>
            </div>
            <div>
              <tbody>
                <tr>
                  <td style={{ width: "90px" }}>Dibuat di</td>
                  <td>: &nbsp;{validValue(item?.legal_nominatif?.tempat)} &nbsp;.</td>
                </tr>
                <tr>
                  <td>Pada Tanggal</td>
                  <td>: &nbsp;{validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")} &nbsp;.</td>
                </tr>
              </tbody>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: "10px",
            }}><div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <tbody>
                <tr>
                  <td style={{ width: "110px" }}>Mengetahui;</td>
                </tr>
                <tr>
                  <td>Kepala Desa</td>
                  <td>{validValue(item?.legal_nominatif?.desa)}.</td>
                </tr>
              </tbody>
              <div style={{ marginTop: "80px" }}>{validValue(item?.legal_nominatif?.kepala_desa)}</div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <tbody>
                <tr>
                  <td style={{ width: "200px", height: "20px" }}></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>Yang membuat Pernyataan</td>
                  <td></td>
                </tr>
              </tbody>
              <div style={{ marginTop: "110px" }}>{validValue(item?.legal_nominatif?.nama)}</div>
            </div>
          </div>

          <p style={{ marginTop: "40px", fontWeight: "bold", textTransform: "capitalize" }}>Saksi-saksi</p>
          <table>
            <tbody>
              <tr>
                <td style={{ width: "80px", paddingTop: "30px" }}>Ketua RT</td>
                <td style={{ paddingTop: "30px" }}> {validValue(item?.legal_nominatif?.ketua_rt)} (.........................................................)</td>
              </tr>
              <tr>
                <td style={{ width: "80px", paddingTop: "30px" }}>Ketua RW</td>
                <td style={{ paddingTop: "30px" }}> {validValue(item?.legal_nominatif?.ketua_rw)} (.........................................................)</td>
              </tr>
              <tr>
                <td style={{ width: "80px", paddingTop: "30px" }}>Ketua Kadus</td>
                <td style={{ paddingTop: "30px" }}> {validValue(item?.legal_nominatif?.kadus)} (.........................................................)</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* ///6/// */}
      {type === "f4-surat-keterangan" && (
        <div ref={innerRef} className="bg-white">
          {item.legal_nominatif && item.legal_nominatif.beralih_kepada_2 && (
            <div style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
              <div style={{ marginBottom: "10px" }}>
                <table style={{ borderCollapse: "collapse", marginTop: "10px" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "150px" }}>PEMERINTAH DESA</td>
                      <td>: {validValue(item?.legal_nominatif?.desa)}</td>
                    </tr>
                    <tr>
                      <td>KECAMATAN</td>
                      <td>: {validValue(item?.legal_nominatif?.kecamatan)}</td>
                    </tr>
                    <tr>
                      <td>KABUPATEN/ KOTA</td>
                      <td>: BOGOR</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline", fontSize: "18px", margin: "20px 0 5px" }}>SURAT KETERANGAN</div>
              <div style={{ textAlign: "center", marginBottom: "20px" }}>NOMOR : ..........................................................</div>
              <p style={{ textAlign: "justify" }}>
                Yang bertandatangan di bawah ini Kepala Desa &nbsp;{validValue(item?.legal_nominatif?.desa)} &nbsp;Kecamatan &nbsp;{validValue(item?.legal_nominatif?.kecamatan)} &nbsp;Kabupaten Bogor Dengan ini memberikan keterangan bahwa Tanah Milik Adat C/SPPT No. &nbsp;{validValue(item?.legal_nominatif?.no_c)} &nbsp;/ &nbsp;{validValue(item?.legal_nominatif?.nop)} &nbsp;Persil &nbsp;{validValue(item?.legal_nominatif?.no_persil)} &nbsp; Seluas &nbsp;
                {validValue(item?.legal_nominatif?.luas_tanah)} &nbsp;M² atas nama &nbsp;{validValue(item?.legal_nominatif?.beralih_kepada_2)} &nbsp;Dapat Hibah / Jual Beli / Pembagian Waris dari C Nomor &nbsp;{validValue(item?.legal_nominatif?.no_c)} &nbsp;Persil &nbsp;{validValue(item?.legal_nominatif?.no_persil)} &nbsp;. Atas nama &nbsp;{validValue(item?.legal_nominatif?.ats_nama_1)} &nbsp;yang terjadi pada tanggal &nbsp;{validValue(item?.legal_nominatif?.tahun_2)} &nbsp;di bawah tangan
                sesuai data administrasi di Desa (Surat Hibah / Jual Beli / Pembagian Waris) tidak ada / tidak dibuat.
              </p>
              <span>Saksi-saksi :</span>
              <table style={{ marginBottom: "10px", marginTop: "10px" }}>
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "30px" }}>1.</td>
                    <td style={{ width: "120px" }}>Nama </td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.saksi_sk_1)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Umur</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>
                      {validValue(item?.legal_nominatif?.umur_sk_1)} &nbsp; {validValue("TAHUN")}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Pekerjaan</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.pekerjaan_sk_1)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Alamat</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.alamat_sk_1)} &nbsp;</td>
                  </tr>
                </tbody>
              </table>
              <table style={{ marginBottom: "10px", marginTop: "10px" }}>
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "30px" }}>2.</td>
                    <td style={{ width: "120px" }}>Nama </td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.saksi_sk_2)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Umur</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>
                      {validValue(item?.legal_nominatif?.umur_sk_2)} &nbsp; {validValue("TAHUN")}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Pekerjaan</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.pekerjaan_sk_2)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Alamat</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.alamat_sk_2)} &nbsp;</td>
                  </tr>
                </tbody>
              </table>
              <p>Demikian Surat keterangan ini dibuat dengan sebenarnya untuk melengkapi persyaratan pembuatan sertifikat.</p>
              <div style={{ marginTop: "60px" }}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "50%" }}>
                        <p>Saksi-saksi :</p>
                        <table>
                          <tbody>
                            <tr>
                              <td style={{ width: "30px", paddingTop: "40px" }}>1.</td>
                              <td style={{ paddingTop: "40px" }}>{validValue(item?.legal_nominatif?.saksi_sk_1)} (.........................................................)</td>
                            </tr>
                            <tr>
                              <td style={{ width: "30px", paddingTop: "40px" }}>2.</td>
                              <td style={{ paddingTop: "40px" }}>{validValue(item?.legal_nominatif?.saksi_sk_2)} (.........................................................)</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <div>
                          {validValue(item?.legal_nominatif?.tempat)}, {validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")}.
                        </div>
                        <div style={{ marginBottom: "100px" }}>
                          KEPALA DESA <b>{item?.legal_nominatif?.desa}</b>
                        </div>
                        <div>({validValue(item?.legal_nominatif?.kepala_desa)})</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="pagebreak" style={{ pageBreakAfter: "always" }}>
                <style>{`@media print { .pagebreak { page-break-after: always; } }`}</style>
              </div>
            </div>
          )}

          {item.legal_nominatif && item.legal_nominatif.beralih_kepada_3 && (
            <div style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
              <div style={{ marginBottom: "10px" }}>
                <table style={{ borderCollapse: "collapse", marginTop: "10px" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "150px" }}>PEMERINTAH DESA</td>
                      <td>: {validValue(item?.legal_nominatif?.desa)}</td>
                    </tr>
                    <tr>
                      <td>KECAMATAN</td>
                      <td>: {validValue(item?.legal_nominatif?.kecamatan)}</td>
                    </tr>
                    <tr>
                      <td>KABUPATEN/ KOTA</td>
                      <td>: BOGOR</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline", fontSize: "18px", margin: "20px 0 5px" }}>SURAT KETERANGAN</div>
              <div style={{ textAlign: "center", marginBottom: "20px" }}>NOMOR : ..........................................................</div>
              <p style={{ textAlign: "justify" }}>
                Yang bertandatangan di bawah ini Kepala Desa &nbsp;{validValue(item?.legal_nominatif?.desa)} &nbsp;Kecamatan &nbsp;{validValue(item?.legal_nominatif?.kecamatan)} &nbsp;Kabupaten Bogor Dengan ini memberikan keterangan bahwa Tanah Milik Adat C/SPPT No. &nbsp;{validValue(item?.legal_nominatif?.no_c)} &nbsp;/ &nbsp;{validValue(item?.legal_nominatif?.nop)} &nbsp;Persil &nbsp;{validValue(item?.legal_nominatif?.no_persil)} &nbsp; Seluas &nbsp;
                {validValue(item?.legal_nominatif?.luas_tanah)} &nbsp;M² atas nama &nbsp;{validValue(item?.legal_nominatif?.beralih_kepada_3)} &nbsp;Dapat Hibah / Jual Beli / Pembagian Waris dari C Nomor &nbsp;{validValue(item?.legal_nominatif?.no_c)} &nbsp;Persil &nbsp;{validValue(item?.legal_nominatif?.no_persil)} &nbsp;. Atas nama &nbsp;{validValue(item?.legal_nominatif?.beralih_kepada_2)} &nbsp;yang terjadi pada tanggal &nbsp;{validValue(item?.legal_nominatif?.tahun_3)} &nbsp;di bawah tangan
                sesuai data administrasi di Desa (Surat Hibah / Jual Beli / Pembagian Waris) tidak ada / tidak dibuat.
              </p>
              <span>Saksi-saksi :</span>
              <table style={{ marginBottom: "10px", marginTop: "10px" }}>
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "30px" }}>1.</td>
                    <td style={{ width: "120px" }}>Nama </td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.saksi_sk_1)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Umur</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>
                      {validValue(item?.legal_nominatif?.umur_sk_1)} &nbsp; {validValue("TAHUN")}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Pekerjaan</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.pekerjaan_sk_1)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Alamat</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.alamat_sk_1)} &nbsp;</td>
                  </tr>
                </tbody>
              </table>
              <table style={{ marginBottom: "10px", marginTop: "10px" }}>
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "30px" }}>2.</td>
                    <td style={{ width: "120px" }}>Nama </td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.saksi_sk_2)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Umur</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>
                      {validValue(item?.legal_nominatif?.umur_sk_2)} &nbsp; {validValue("TAHUN")}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Pekerjaan</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.pekerjaan_sk_2)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Alamat</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.alamat_sk_2)} &nbsp;</td>
                  </tr>
                </tbody>
              </table>
              <p>Demikian Surat keterangan ini dibuat dengan sebenarnya untuk melengkapi persyaratan pembuatan sertifikat.</p>
              <div style={{ marginTop: "60px" }}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "50%" }}>
                        <p>Saksi-saksi :</p>
                        <table>
                          <tbody>
                            <tr>
                              <td style={{ width: "30px", paddingTop: "40px" }}>1.</td>
                              <td style={{ paddingTop: "40px" }}>{validValue(item?.legal_nominatif?.saksi_sk_1)} (.........................................................)</td>
                            </tr>
                            <tr>
                              <td style={{ width: "30px", paddingTop: "40px" }}>2.</td>
                              <td style={{ paddingTop: "40px" }}>{validValue(item?.legal_nominatif?.saksi_sk_2)} (.........................................................)</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <div>
                          {validValue(item?.legal_nominatif?.tempat)}, {validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")}.
                        </div>
                        <div style={{ marginBottom: "100px" }}>
                          KEPALA DESA <b>{item?.legal_nominatif?.desa}</b>
                        </div>
                        <div>({validValue(item?.legal_nominatif?.kepala_desa)})</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="pagebreak" style={{ pageBreakAfter: "always" }}>
                <style>{`@media print { .pagebreak { page-break-after: always; } }`}</style>
              </div>
            </div>
          )}

          {item.legal_nominatif && item.legal_nominatif.beralih_kepada_4 && (
            <div style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
              <div style={{ marginBottom: "10px" }}>
                <table style={{ borderCollapse: "collapse", marginTop: "10px" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "150px" }}>PEMERINTAH DESA</td>
                      <td>: {validValue(item?.legal_nominatif?.desa)}</td>
                    </tr>
                    <tr>
                      <td>KECAMATAN</td>
                      <td>: {validValue(item?.legal_nominatif?.kecamatan)}</td>
                    </tr>
                    <tr>
                      <td>KABUPATEN/ KOTA</td>
                      <td>: BOGOR</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline", fontSize: "18px", margin: "20px 0 5px" }}>SURAT KETERANGAN</div>
              <div style={{ textAlign: "center", marginBottom: "20px" }}>NOMOR : ..........................................................</div>
              <p style={{ textAlign: "justify" }}>
                Yang bertandatangan di bawah ini Kepala Desa &nbsp;{validValue(item?.legal_nominatif?.desa)} &nbsp;Kecamatan &nbsp;{validValue(item?.legal_nominatif?.kecamatan)} &nbsp;Kabupaten Bogor Dengan ini memberikan keterangan bahwa Tanah Milik Adat C/SPPT No. &nbsp;{validValue(item?.legal_nominatif?.no_c)} &nbsp;/ &nbsp;{validValue(item?.legal_nominatif?.nop)} &nbsp;Persil &nbsp;{validValue(item?.legal_nominatif?.no_persil)} &nbsp; Seluas &nbsp;
                {validValue(item?.legal_nominatif?.luas_tanah)} &nbsp;M² atas nama &nbsp;{validValue(item?.legal_nominatif?.beralih_kepada_4)} &nbsp;Dapat Hibah / Jual Beli / Pembagian Waris dari C Nomor &nbsp;{validValue(item?.legal_nominatif?.no_c)} &nbsp;Persil &nbsp;{validValue(item?.legal_nominatif?.no_persil)} &nbsp;. Atas nama &nbsp;{validValue(item?.legal_nominatif?.beralih_kepada_3)} &nbsp;yang terjadi pada tanggal &nbsp;{validValue(item?.legal_nominatif?.tahun_4)} &nbsp;di bawah tangan
                sesuai data administrasi di Desa (Surat Hibah / Jual Beli / Pembagian Waris) tidak ada / tidak dibuat.
              </p>
              <span>Saksi-saksi :</span>
              <table style={{ marginBottom: "10px", marginTop: "10px" }}>
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "30px" }}>1.</td>
                    <td style={{ width: "120px" }}>Nama </td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.saksi_sk_1)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Umur</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.umur_sk_1)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Pekerjaan</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.pekerjaan_sk_1)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Alamat</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.alamat_sk_1)} &nbsp;</td>
                  </tr>
                </tbody>
              </table>
              <table style={{ marginBottom: "10px", marginTop: "10px" }}>
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "30px" }}>2.</td>
                    <td style={{ width: "120px" }}>Nama </td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.saksi_sk_2)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Umur</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.umur_sk_2)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Pekerjaan</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.pekerjaan_sk_2)} &nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}></td>
                    <td>Alamat</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.legal_nominatif?.alamat_sk_2)} &nbsp;</td>
                  </tr>
                </tbody>
              </table>
              <p>Demikian Surat keterangan ini dibuat dengan sebenarnya untuk melengkapi persyaratan pembuatan sertifikat.</p>
              <div style={{ marginTop: "60px" }}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "50%" }}>
                        <p>Saksi-saksi :</p>
                        <table>
                          <tbody>
                            <tr>
                              <td style={{ width: "30px", paddingTop: "40px" }}>1.</td>
                              <td style={{ paddingTop: "40px" }}>{validValue(item?.legal_nominatif?.saksi_sk_1)} (.........................................................)</td>
                            </tr>
                            <tr>
                              <td style={{ width: "30px", paddingTop: "40px" }}>2.</td>
                              <td style={{ paddingTop: "40px" }}>{validValue(item?.legal_nominatif?.saksi_sk_2)} (.........................................................)</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <div>
                          {validValue(item?.legal_nominatif?.tempat)}, {validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")}.
                        </div>
                        <div style={{ marginBottom: "100px" }}>
                          KEPALA DESA <b>{item?.legal_nominatif?.desa}</b>
                        </div>
                        <div>({validValue(item?.legal_nominatif?.kepala_desa)})</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ///7/// */}
      {type === "f4-tabel" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          {/* <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div> */}
          {item?.legal_nominatif?.ats_nama_1 && (
            <div style={{ paddingTop: "40px", position: "relative" }}>
              <div style={{ position: "absolute", height: "auto", textAlign: "center", padding: "10px", width: "24%", top: "40%", left: "36%", background: "rgba(255, 255, 255, 0.9)" }}>
                <p>Salinan C ini disesuaikan dengan Buku Induk Desa aslinya</p>
                <p style={{ marginBottom: "100px" }}>
                  <b>{item?.legal_nominatif?.desa}</b> ........... ............................
                </p>
                <p style={{ marginBottom: "5px" }}>
                  KEPALA DESA <b>{item?.legal_nominatif?.desa}</b>
                </p>
                <p>
                  <b>{item?.legal_nominatif?.kepala_desa}</b>
                </p>
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px", marginBottom: "20px" }}>
                <thead>
                  <tr>
                    <td colSpan={5} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      NAMA W.P : {validValue(item?.legal_nominatif?.ats_nama_1)}
                    </td>
                    <td colSpan={4} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      NO : {validValue(item?.legal_nominatif?.no_c)}
                    </td>
                    <td colSpan={5} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      ALAMAT : {validValue(item?.legal_nominatif?.kota_1)}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center", fontWeight: "bold", border: "1px solid black" }}>
                      SAWAH
                    </td>
                    <td colSpan={7} style={{ textAlign: "center", fontWeight: "bold", border: "1px solid black" }}>
                      DARAT
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "start", border: "1px solid black" }}>Nomor</td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td colSpan={4} style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}>Nomor</td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td colSpan={4} style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                  </tr>
                  <tr>
                    <td rowSpan={3} style={cellStyle}>
                      Persil dan huruf bagian persil
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Kelas Desa
                    </td>
                    <td colSpan={4} style={cellStyle}>
                      Menurut daftar perincian
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Sebab dan tanggal perubahan
                    </td>

                    <td rowSpan={3} style={cellStyle}>
                      Persil dan huruf bagian persil
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Kelas Desa
                    </td>
                    <td colSpan={4} style={cellStyle}>
                      Menurut daftar perincian
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Sebab dan tanggal perubahan
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={cellStyle}>
                      Luas milik (ha)
                    </td>
                    <td colSpan={2} style={cellStyle}>
                      Ipeda
                    </td>

                    <td colSpan={2} style={cellStyle}>
                      Luas milik (ha)
                    </td>
                    <td colSpan={2} style={cellStyle}>
                      Ipeda
                    </td>
                  </tr>
                  <tr>
                    <td style={cellStyle}>ha</td>
                    <td style={cellStyle}>da</td>
                    <td style={cellStyle}>R</td>
                    <td style={cellStyle}>S</td>
                    <td style={cellStyle}>ha</td>
                    <td style={cellStyle}>da</td>
                    <td style={cellStyle}>R</td>
                    <td style={cellStyle}>S</td>
                  </tr>
                </thead>
                <tbody>
                  {item?.legal_nominatif?.blankoc === "DARAT" ? (
                    <tr>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.no_persil)}</td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.kelas_desa)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.luas_tanah)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                    </tr>
                  ) : (
                    <tr>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.no_persil)}</td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.kelas_desa)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.luas_tanah)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                    </tr>
                  )}
                  {(() => {
                    let tr = [];
                    for (let i = 1; i <= 65; i++) {
                      tr.push(
                        <tr>
                          {Array.from({ length: 14 }).map((_, colIdx) => (
                            <td key={colIdx} style={cellStyle}></td>
                          ))}
                        </tr>
                      );
                    }
                    return tr;
                  })()}
                </tbody>
              </table>
              <div className="pagebreak" style={{ pageBreakAfter: "always" }}>
                <style>{`@media print { .pagebreak { page-break-after: always; } }`}</style>
              </div>
            </div>
          )}
          {item?.legal_nominatif?.beralih_kepada_2 && (
            <div style={{ paddingTop: "40px", position: "relative" }}>
              <div style={{ position: "absolute", height: "auto", textAlign: "center", padding: "10px", width: "24%", top: "40%", left: "36%", background: "rgba(255, 255, 255, 0.9)" }}>
                <p>Salinan C ini disesuaikan dengan Buku Induk Desa aslinya</p>
                <p style={{ marginBottom: "100px" }}>
                  <b>{item?.legal_nominatif?.desa}</b> ........... ............................
                </p>
                <p style={{ marginBottom: "5px" }}>
                  KEPALA DESA <b>{item?.legal_nominatif?.desa}</b>
                </p>
                <p>
                  <b>{item?.legal_nominatif?.kepala_desa}</b>
                </p>
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px", marginBottom: "20px" }}>
                <thead>
                  <tr>
                    <td colSpan={5} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      NAMA W.P : {validValue(item?.legal_nominatif?.beralih_kepada_2)}
                    </td>
                    <td colSpan={4} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      NO : {validValue(item?.legal_nominatif?.no_c)}
                    </td>
                    <td colSpan={5} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      ALAMAT : {validValue(item?.legal_nominatif?.kota_2)}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center", fontWeight: "bold", border: "1px solid black" }}>
                      SAWAH
                    </td>
                    <td colSpan={7} style={{ textAlign: "center", fontWeight: "bold", border: "1px solid black" }}>
                      DARAT
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "start", border: "1px solid black" }}>Nomor</td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td colSpan={4} style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}>Nomor</td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td colSpan={4} style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                  </tr>
                  <tr>
                    <td rowSpan={3} style={cellStyle}>
                      Persil dan huruf bagian persil
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Kelas Desa
                    </td>
                    <td colSpan={4} style={cellStyle}>
                      Menurut daftar perincian
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Sebab dan tanggal perubahan
                    </td>

                    <td rowSpan={3} style={cellStyle}>
                      Persil dan huruf bagian persil
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Kelas Desa
                    </td>
                    <td colSpan={4} style={cellStyle}>
                      Menurut daftar perincian
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Sebab dan tanggal perubahan
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={cellStyle}>
                      Luas milik (ha)
                    </td>
                    <td colSpan={2} style={cellStyle}>
                      Ipeda
                    </td>

                    <td colSpan={2} style={cellStyle}>
                      Luas milik (ha)
                    </td>
                    <td colSpan={2} style={cellStyle}>
                      Ipeda
                    </td>
                  </tr>
                  <tr>
                    <td style={cellStyle}>ha</td>
                    <td style={cellStyle}>da</td>
                    <td style={cellStyle}>R</td>
                    <td style={cellStyle}>S</td>
                    <td style={cellStyle}>ha</td>
                    <td style={cellStyle}>da</td>
                    <td style={cellStyle}>R</td>
                    <td style={cellStyle}>S</td>
                  </tr>
                </thead>
                <tbody>
                  {item?.legal_nominatif?.blankoc === "DARAT" ? (
                    <tr>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.no_persil)}</td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.kelas_desa)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.luas_tanah)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                    </tr>
                  ) : (
                    <tr>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.no_persil)}</td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.kelas_desa)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.luas_tanah)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                    </tr>
                  )}
                  {(() => {
                    let tr = [];
                    for (let i = 1; i <= 65; i++) {
                      tr.push(
                        <tr>
                          {Array.from({ length: 14 }).map((_, colIdx) => (
                            <td key={colIdx} style={cellStyle}></td>
                          ))}
                        </tr>
                      );
                    }
                    return tr;
                  })()}
                </tbody>
              </table>
              <div className="pagebreak" style={{ pageBreakAfter: "always" }}>
                <style>{`@media print { .pagebreak { page-break-after: always; } }`}</style>
              </div>
            </div>
          )}

          {item?.legal_nominatif?.beralih_kepada_3 && (
            <div style={{ paddingTop: "40px", position: "relative" }}>
              <div style={{ position: "absolute", height: "auto", textAlign: "center", padding: "10px", width: "24%", top: "40%", left: "36%", background: "rgba(255, 255, 255, 0.9)" }}>
                <p>Salinan C ini disesuaikan dengan Buku Induk Desa aslinya</p>
                <p style={{ marginBottom: "100px" }}>
                  <b>{item?.legal_nominatif?.desa}</b> ........... ............................
                </p>
                <p style={{ marginBottom: "5px" }}>
                  KEPALA DESA <b>{item?.legal_nominatif?.desa}</b>
                </p>
                <p>
                  <b>{item?.legal_nominatif?.kepala_desa}</b>
                </p>
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px", marginBottom: "20px" }}>
                <thead>
                  <tr>
                    <td colSpan={5} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      NAMA W.P : {validValue(item?.legal_nominatif?.beralih_kepada_3)}
                    </td>
                    <td colSpan={4} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      NO : {validValue(item?.legal_nominatif?.no_c)}
                    </td>
                    <td colSpan={5} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      ALAMAT : {validValue(item?.legal_nominatif?.kota_3)}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center", fontWeight: "bold", border: "1px solid black" }}>
                      SAWAH
                    </td>
                    <td colSpan={7} style={{ textAlign: "center", fontWeight: "bold", border: "1px solid black" }}>
                      DARAT
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "start", border: "1px solid black" }}>Nomor</td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td colSpan={4} style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}>Nomor</td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td colSpan={4} style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                  </tr>
                  <tr>
                    <td rowSpan={3} style={cellStyle}>
                      Persil dan huruf bagian persil
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Kelas Desa
                    </td>
                    <td colSpan={4} style={cellStyle}>
                      Menurut daftar perincian
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Sebab dan tanggal perubahan
                    </td>

                    <td rowSpan={3} style={cellStyle}>
                      Persil dan huruf bagian persil
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Kelas Desa
                    </td>
                    <td colSpan={4} style={cellStyle}>
                      Menurut daftar perincian
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Sebab dan tanggal perubahan
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={cellStyle}>
                      Luas milik (ha)
                    </td>
                    <td colSpan={2} style={cellStyle}>
                      Ipeda
                    </td>

                    <td colSpan={2} style={cellStyle}>
                      Luas milik (ha)
                    </td>
                    <td colSpan={2} style={cellStyle}>
                      Ipeda
                    </td>
                  </tr>
                  <tr>
                    <td style={cellStyle}>ha</td>
                    <td style={cellStyle}>da</td>
                    <td style={cellStyle}>R</td>
                    <td style={cellStyle}>S</td>
                    <td style={cellStyle}>ha</td>
                    <td style={cellStyle}>da</td>
                    <td style={cellStyle}>R</td>
                    <td style={cellStyle}>S</td>
                  </tr>
                </thead>
                <tbody>
                  {item?.legal_nominatif?.blankoc === "DARAT" ? (
                    <tr>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.no_persil)}</td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.kelas_desa)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.luas_tanah)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                    </tr>
                  ) : (
                    <tr>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.no_persil)}</td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.kelas_desa)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.luas_tanah)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                    </tr>
                  )}
                  {(() => {
                    let tr = [];
                    for (let i = 1; i <= 65; i++) {
                      tr.push(
                        <tr>
                          {Array.from({ length: 14 }).map((_, colIdx) => (
                            <td key={colIdx} style={cellStyle}></td>
                          ))}
                        </tr>
                      );
                    }
                    return tr;
                  })()}
                </tbody>
              </table>
              <div className="pagebreak" style={{ pageBreakAfter: "always" }}>
                <style>{`@media print { .pagebreak { page-break-after: always; } }`}</style>
              </div>
            </div>
          )}

          {item?.legal_nominatif?.beralih_kepada_4 && (
            <div style={{ paddingTop: "40px", position: "relative" }}>
              <div style={{ position: "absolute", height: "auto", textAlign: "center", padding: "10px", width: "24%", top: "40%", left: "36%", background: "rgba(255, 255, 255, 0.9)" }}>
                <p>Salinan C ini disesuaikan dengan Buku Induk Desa aslinya</p>
                <p style={{ marginBottom: "100px" }}>
                  <b>{item?.legal_nominatif?.desa}</b> ........... ............................
                </p>
                <p style={{ marginBottom: "5px" }}>
                  KEPALA DESA <b>{item?.legal_nominatif?.desa}</b>
                </p>
                <p>
                  <b>{item?.legal_nominatif?.kepala_desa}</b>
                </p>
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px", marginBottom: "20px" }}>
                <thead>
                  <tr>
                    <td colSpan={5} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      NAMA W.P : {validValue(item?.legal_nominatif?.beralih_kepada_4)}
                    </td>
                    <td colSpan={4} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      NO : {validValue(item?.legal_nominatif?.no_c)}
                    </td>
                    <td colSpan={5} style={{ textAlign: "start", fontWeight: "bold", border: "1px solid black" }}>
                      ALAMAT : {validValue(item?.legal_nominatif?.kota_4)}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center", fontWeight: "bold", border: "1px solid black" }}>
                      SAWAH
                    </td>
                    <td colSpan={7} style={{ textAlign: "center", fontWeight: "bold", border: "1px solid black" }}>
                      DARAT
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "start", border: "1px solid black" }}>Nomor</td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td colSpan={4} style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}>Nomor</td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td colSpan={4} style={{ textAlign: "start", border: "1px solid black" }}></td>
                    <td style={{ textAlign: "start", border: "1px solid black" }}></td>
                  </tr>
                  <tr>
                    <td rowSpan={3} style={cellStyle}>
                      Persil dan huruf bagian persil
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Kelas Desa
                    </td>
                    <td colSpan={4} style={cellStyle}>
                      Menurut daftar perincian
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Sebab dan tanggal perubahan
                    </td>

                    <td rowSpan={3} style={cellStyle}>
                      Persil dan huruf bagian persil
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Kelas Desa
                    </td>
                    <td colSpan={4} style={cellStyle}>
                      Menurut daftar perincian
                    </td>
                    <td rowSpan={3} style={cellStyle}>
                      Sebab dan tanggal perubahan
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={cellStyle}>
                      Luas milik (ha)
                    </td>
                    <td colSpan={2} style={cellStyle}>
                      Ipeda
                    </td>

                    <td colSpan={2} style={cellStyle}>
                      Luas milik (ha)
                    </td>
                    <td colSpan={2} style={cellStyle}>
                      Ipeda
                    </td>
                  </tr>
                  <tr>
                    <td style={cellStyle}>ha</td>
                    <td style={cellStyle}>da</td>
                    <td style={cellStyle}>R</td>
                    <td style={cellStyle}>S</td>
                    <td style={cellStyle}>ha</td>
                    <td style={cellStyle}>da</td>
                    <td style={cellStyle}>R</td>
                    <td style={cellStyle}>S</td>
                  </tr>
                </thead>
                <tbody>
                  {item?.legal_nominatif?.blankoc === "DARAT" ? (
                    <tr>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.no_persil)}</td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.kelas_desa)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.luas_tanah)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                    </tr>
                  ) : (
                    <tr>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.no_persil)}</td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.kelas_desa)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}>{validValue(item?.legal_nominatif?.luas_tanah)}</td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                      <td style={cellStyle}></td>
                    </tr>
                  )}
                  {(() => {
                    let tr = [];
                    for (let i = 1; i <= 65; i++) {
                      tr.push(
                        <tr>
                          {Array.from({ length: 14 }).map((_, colIdx) => (
                            <td key={colIdx} style={cellStyle}></td>
                          ))}
                        </tr>
                      );
                    }
                    return tr;
                  })()}
                </tbody>
              </table>
              <div className="pagebreak" style={{ pageBreakAfter: "always" }}>
                <style>{`@media print { .pagebreak { page-break-after: always; } }`}</style>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ///8// */}

      {type === "f4-surat-persetujuan-pasangan-atau-anak" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "80px 80px 80px 80px", fontSize: "12px" }}>
          <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px", marginBottom: "10px" }}> SURAT PERSETUJUAN PASANGAN/ANAK</div>
          <div style={{ height: "1px", width: "100%", backgroundColor: "black", marginBottom: "30px" }}></div>
          <p>Yang bertanda tangan di bawah ini:</p>
          <table style={{ marginBottom: "10px" }}>
            <tbody>
              <tr>
                <td style={{ width: "180px" }}>Nama</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.nama_pasangan)}</td>
              </tr>
              <tr>
                <td>Tempat/Tanggal Lahir</td>
                <td style={{ width: "20px" }}>:</td>
                <td>
                  {validValue(item?.legal_nominatif?.tempat_lhr_pasangan)}, {validValue(item?.legal_nominatif?.tanggal_lhr_pasangan && handleValidDate(item?.legal_nominatif?.tanggal_lhr_pasangan))}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.pekerjaan_pasangan)}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.alamat_pasangan)}</td>
              </tr>
              <tr>
                <td>No. KTP</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.ktp_pasangan)}</td>
              </tr>
            </tbody>
          </table>
          <p>Dalam hal ini bertindak dalam kapasitas sebagai istri/suami/anak yang sah dari suami/istri/anak yang bersangkutan, dengan identitas sebagai berikut:</p>
          <table style={{ marginBottom: "10px" }}>
            <tbody>
              <tr>
                <td style={{ width: "180px" }}>Nama</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.nama)}</td>
              </tr>
              <tr>
                <td>Tempat/Tanggal Lahir</td>
                <td style={{ width: "20px" }}>:</td>
                <td>
                  {validValue(item?.legal_nominatif?.tempat_lahir)}, {validValue(item?.legal_nominatif?.tgl_lahir && handleValidDate(item?.legal_nominatif?.tgl_lahir))}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.pekerjaan && item?.legal_nominatif?.pekerjaan)}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.alamat_1)}</td>
              </tr>
              <tr>
                <td>No. KTP</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.ktp)}</td>
              </tr>
            </tbody>
          </table>

          <p>
            Dengan ini menyatakan dengan sebenar-benarnya bahwa saya menyetujui suami/istri/anak saya tersebut untuk menjual hak atas tanahnya kepada {validValue(item?.legal_nominatif?.alih_2)} atas sebidang Hak Milik dengan Sertifikat Hak Milik (SHM) / C Nomor {validValue(item?.legal_nominatif?.no_c)} No Persil {validValue(item?.legal_nominatif?.no_persil)} atas nama {validValue(item?.legal_nominatif?.nama)} tanggal {validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")} yang terletak di Kabupaten
            {validValue(item?.legal_nominatif?.kabupaten || " BOGOR")} Provinsi {validValue(item?.legal_nominatif?.provinsi || "JAWA BARAT")} RT {validValue(item?.legal_nominatif?.rt)} RW {validValue(item?.legal_nominatif?.rw)} Kecamatan {validValue(item?.legal_nominatif?.kecamatan)} Kelurahan {validValue(item?.legal_nominatif?.desa)}
          </p>

          <p>Demikian pernyataan ini saya buat dengan sebenar-benarnya tanpa ada paksaan dari pihak manapun.</p>

          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px" }}>
            <div style={{ textAlign: "center" }}>
              <p>
                {" "}
              </p>
              <p>Yang menyatakan,</p>
              <div style={{ height: "110px" }}></div>
              <p>{validValue(item?.legal_nominatif?.nama)}</p>
            </div>
            <div style={{ textAlign: "center" }}>
              <p style={{ marginBottom: "0px" }}>
                {validValue(item?.legal_nominatif?.tempat)}, {validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")}
              </p>
              <p>Yang menyetujui,</p>
              <div style={{ height: "110px" }}></div>
              <p>{validValue(item?.legal_nominatif?.nama_pasangan)}</p>
            </div>
          </div>
        </div>
      )}
      {/* ///9/// */}
      {type === "f4-surat-persetujuan-anak" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "80px 80px 80px 80px", fontSize: "12px" }}>
          <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px", marginBottom: "10px" }}> SURAT PERNYATAAN </div>
          <div style={{ height: "1px", width: "100%", backgroundColor: "black", marginBottom: "30px" }}></div>
          <p>Yang bertanda tangan di bawah ini:</p>
          <table style={{ marginBottom: "10px" }}>
            <tbody>
              <tr>
                <td style={{ width: "180px" }}>Nama</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.nama_pasangan)}</td>
              </tr>
              <tr>
                <td>Tempat/Tanggal Lahir</td>
                <td style={{ width: "20px" }}>:</td>
                <td>
                  {validValue(item?.legal_nominatif?.tempat_lhr_pasangan)}, {validValue(item?.legal_nominatif?.tanggal_lhr_pasangan && handleValidDate(item?.legal_nominatif?.tanggal_lhr_pasangan))}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.pekerjaan_pasangan)}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.alamat_pasangan)}</td>
              </tr>
              <tr>
                <td>No. KTP</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.ktp_pasangan)}</td>
              </tr>
            </tbody>
          </table>
          <p>Dalam hal ini bertindak selaku anak yang sah dari suami/istri sebagai berikut:</p>
          <table style={{ marginBottom: "10px" }}>
            <tbody>
              <tr>
                <td style={{ width: "180px" }}>Nama</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.nama)}</td>
              </tr>
              <tr>
                <td>Tempat/Tanggal Lahir</td>
                <td style={{ width: "20px" }}>:</td>
                <td>
                  {validValue(item?.legal_nominatif?.tempat_lahir)}, {validValue(item?.legal_nominatif?.tgl_lahir && handleValidDate(item?.legal_nominatif?.tgl_lahir))}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.pekerjaan && item?.legal_nominatif?.pekerjaan)}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.alamat_1)}</td>
              </tr>
              <tr>
                <td>No. KTP</td>
                <td style={{ width: "20px" }}>:</td>
                <td>{validValue(item?.legal_nominatif?.ktp)}</td>
              </tr>
            </tbody>
          </table>

          <p>
            Dengan ini menyatakan dengan sebenar-benarnya bahwa saya menyetujui bapak/ibu {validValue(item?.legal_nominatif?.nama)} tersebut untuk menjual hak atas tanahnya kepada {validValue(item?.legal_nominatif?.alih_2)} atas sebidang Hak Milik dengan Sertifikat Hak Milik (SHM) / C Nomor {validValue(item?.legal_nominatif?.no_c)} No Persil {validValue(item?.legal_nominatif?.no_persil)} atas nama {validValue(item?.legal_nominatif?.nama)} tanggal {validValue(handleValidDate(item?.legal_nominatif?.tgl))} yang terletak di Kabupaten
            {validValue(item?.legal_nominatif?.kabupaten || "BOGOR")} Provinsi {validValue(item?.legal_nominatif?.provinsi || "JAWA BARAT")} RT {validValue(item?.legal_nominatif?.rt)} RW {validValue(item?.legal_nominatif?.rw)} Kecamatan {validValue(item?.legal_nominatif?.kecamatan)} Kelurahan {validValue(item?.legal_nominatif?.desa)}
          </p>

          <p>Demikian pernyataan ini saya buat dengan sebenar-benarnya tanpa ada paksaan dari pihak manapun.</p>

          <div style={{ display: "flex", justifyContent: "flex-start", marginTop: "30px" }}>
            <div style={{ textAlign: "center" }}>
              <p>
                {validValue(item?.legal_nominatif?.tempat)}, {validValue(item?.legal_nominatif?.tgl ? handleValidDate(item?.legal_nominatif?.tgl) : "")}
              </p>
              <p>Yang menyatakan,</p>
              <div style={{ height: "110px" }}></div>
              <p>{validValue(item?.legal_nominatif?.nama_pasangan)}</p>
            </div>
          </div>
        </div>
      )}

      {/* ///10/// */}
      {type === "a3-sph" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 60px 40px 60px", fontSize: "14px" }}>
          <div
            style={{
              paddingTop: "40px",
            }}><table>
              <tr>
                <td style={{ width: "54%" }}></td>
                <td style={{ width: "54%" }}>
                  <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px", textTransform: "uppercase" }}>
                    SURAT PERNYATAAN PELEPASAN HAK ATAS TANAH <br />
                    UNTUK KEPENTINGAN SWASTA
                  </div>
                  <div style={{ marginTop: "40px", marginBottom: "40px", textAlign: "center" }}>No. ......................................................................................</div>
                  <p>Yang bertandatangan dibawah ini :</p>
                  <table style={{ borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "180px" }}>Nama</td>
                        <td style={{ width: "30px", textAlign: "center" }}>:</td>
                        <td>
                          <span className="courier-prime-bold text-capitalize">{validValue((item?.legal_nominatif?.nama ?? "").toLowerCase())}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Umur</td>
                        <td style={{ width: "30px", textAlign: "center" }}>:</td>
                        <td>
                          <span className="courier-prime-bold text-capitalize">{item?.legal_nominatif?.usia} Tahun</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Kewarganegaraan</td>
                        <td style={{ width: "30px", textAlign: "center" }}>:</td>
                        <td>
                          <span className="courier-prime-bold text-capitalize">{validValue((item?.legal_nominatif?.warga_negara ?? "").toLowerCase())}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Pekerjaan</td>
                        <td style={{ width: "30px", textAlign: "center" }}>:</td>
                        <td>
                          <span className="courier-prime-bold text-capitalize">{validValue(item?.legal_nominatif?.pekerjaan && (item?.legal_nominatif?.pekerjaan ?? "").toLowerCase())}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "top" }}>Tempat Tinggal / KTP No.</td>
                        <td style={{ width: "30px", textAlign: "center", verticalAlign: "top" }}>:</td>
                        <td>
                          <span className="courier-prime-bold">{item?.legal_nominatif?.alamat_1}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p style={{ textAlign: "justify" }}>Dengan penuh kesadaran dan tanggung jawab, dengan ini saya selaku pemilik tanah menyatakan sebagai berikut :</p>
                  <ol style={{ paddingLeft: "10px", textAlign: "justify" }}>
                    <li>
                      Saya tersebut di atas menyatakan melepaskan hak atas tanah saya yang tercatat dalam {item?.legal_nominatif?.isCert ? "Sertifikat" : "Girik"} <span className="courier-prime-bold text-capitalize">{validValue((item?.legal_nominatif?.dasar ?? "").toLowerCase())}</span> No. <span className="courier-prime-bold text-capitalize">{item?.legal_nominatif?.no_c}</span> Persil No <span className="courier-prime-bold text-capitalize">{item?.legal_nominatif?.no_persil}</span> Kelas
                      <span className="courier-prime-bold text-capitalize">{item?.legal_nominatif?.kelas_desa}</span> berjenis <span className="courier-prime-bold text-capitalize">{validValue((item?.legal_nominatif?.jenis ?? "").toLowerCase())}</span> Dengan luas tanah berdasarkan {item?.legal_nominatif?.isCert ? "Sertifikat" : "Girik"} tersebut lebih kurang ada <span className="courier-prime-bold text-capitalize">{currencyFormat(item?.legal_nominatif?.luas_tanah)}</span> m² terletak di blok
                      <span className="courier-prime-bold text-capitalize">{(item?.legal_nominatif?.blok ?? "").toLowerCase()} </span>Desa <span className="courier-prime-bold text-capitalize">{validValue((item?.legal_nominatif?.desa ?? "").toLowerCase())}</span> Kecamatan <span className="courier-prime-bold text-capitalize">{validValue((item?.legal_nominatif?.kecamatan ?? "").toLowerCase())}</span> Kabupaten Bogor.
                    </li>
                    <li>Tanah tersebut {item?.legal_nominatif?.isCert ? "sudah ada" : "belum ada"} sertifikatnya.</li>
                    <li>
                      Bahwa Tanah tersebut akan dilepaskan haknya seluas <span className="courier-prime-bold text-capitalize">{currencyFormat(item?.legal_nominatif?.luas_tanah)}</span> m², luas tanah tersebut adalah merupakan hasil pengukuran / gambar situasi.
                    </li>
                    <li>Tanah tersebut akan saya lepaskan seluruhnya / sebagian.</li>
                    {/* <span className="courier-prime-bold text-capitalize">{currencyFormat(item?.legal_nominatif?.luas_tanah)}</span> */}
                    <li>
                      Sisa tanah yang belum dilepaskan haknya lebih kurang ada ................... m² tercatat dalam {item?.legal_nominatif?.isCert ? "Sertifikat" : "Girik"} No. ..............................................
                    </li>
                    <li>
                      Bahwa kami benar telah menerima uang ganti rugi sebagai berikut :
                      <table style={{ marginTop: "10px", marginLeft: "0px" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>a. Ganti rugi tanah</td>
                            <td style={{ width: "15%" }}>
                              <span className="courier-prime-bold text-capitalize">{currencyFormat(item?.legal_nominatif?.luas_tanah)}</span> m²
                            </td>
                            <td style={{ width: "5%" }}>=</td>
                            <td style={{ width: "30%" }}>
                              Rp. <span className="courier-prime-bold text-capitalize">{currencyFormat(item?.legal_nominatif?.harga)}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>b. Ganti rugi bangunan seluas</td>
                            <td></td>
                            <td>=</td>
                            <td>Rp. ..................</td>
                          </tr>
                          <tr>
                            <td>c. Ganti rugi tanaman seluas - m²</td>
                            <td></td>
                            <td>=</td>
                            <td>Rp. ..................</td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ textAlign: "right" }}>
                              Jumlah
                            </td>
                            <td></td>
                            <td className="courier-prime-bold text-capitalize">
                              Rp. <span className="courier-prime-bold text-capitalize">{currencyFormat(item?.legal_nominatif?.harga)}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div>
                        <span className="courier-prime-bold text-capitalize">{validValue((item?.legal_nominatif?.terbilang_harga ?? "").toLowerCase())}</span>
                      </div>
                      <div>
                        dari <span className="courier-prime-bold">{item?.legal_nominatif?.alih_2}</span>
                      </div>
                    </li>
                    <li>Bahwa uang ganti rugi yang diterima tersebut di atas adalah merupakan hasil musyawarah bersama pada hari .......................................... tanggal .......................................... tanpa ada tekanan dan paksaan dari pihak lain.</li>
                  </ol>
                  <div style={{ textAlign: "right", marginTop: "40px" }}>8. Dengan telah …………………</div>
                </td>
              </tr>
            </table>
          </div>
          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <div
            style={{
              paddingTop: "40px",
            }}><table
              style={{
                marginTop: "60px",
              }}>
              <tr>
                <td style={{ width: "54%" }}></td>
                <td style={{ width: "54%" }}>
                  <ol start={8} style={{ paddingLeft: "10px", textAlign: "justify" }}>
                    <li>
                      Dengan telah diterimanya uang ganti rugi tersebut di atas, kami menyatakan tanah yang dilepaskan haknya menjadi tanah negara untuk kemudian dapat diberikan haknya kepada &nbsp; &nbsp; <span className="courier-prime-bold">{item?.legal_nominatif?.alih_2}</span> dari Bupati Kabupaten Bogor, Surat Ijin Lokasi No. <span className="courier-prime-bold text-capitalize">{validValue2((item?.legal_nominatif?.no_ijin_lksi ?? "").toLowerCase())}</span> digunakan untuk pembangunan perumahan
                    </li>
                    <li>Bahwa tanah yang dilepaskan haknya itu tidak dalam keadaan sengketa baik mengenai batas maupun luasnya dan pemiliknya tidak dalam gugatan, tidak dalam sitaan yang berwajib atau proses perkara pengadilan dan tidak digadaikan/dijaminkan kepada pihak lain.</li>
                    <li>Bahwa ahli waris kami maupun pihak – pihak yang tidak berhak menggugat tanah yang telah dilepaskan haknya itu baik sekarang maupun yang akan datang.</li>
                    <li>Batas – batas tanah yang dilepaskan haknya itu dijelaskan dalam gambar situasi terlampir.</li>
                    <li>Semua untung rugi yang mungkin timbul dan hal – hal lain yang dapat menimbulkan gugatan kembali hak atas tanah akibat dari pada pelepasan hak ini, seluruhnya menjadi tanggung jawab yang melepaskan hak tersebut.</li>
                  </ol>

                  <p style={{ textAlign: "justify" }}>
                    Surat pernyataan pelepasan hak ini dibuat di hadapan Camat <span className="courier-prime-bold text-capitalize">{item?.legal_nominatif?.kecamatan.toLowerCase()}</span> Kabupaten Bogor pada hari .................. tanggal ................................................................ Yang disaksikan oleh Kepala Desa dan Sekdes <span className="courier-prime-bold text-capitalize">{validValue((item?.legal_nominatif?.desa ?? "").toLowerCase())}</span> diketahui oleh Camat <span className="courier-prime-bold text-capitalize">{validValue((item?.legal_nominatif?.kecamatan ?? "").toLowerCase())}</span> dalam rangkap 6 (enam) untuk dipergunakan sebagaimana mestinya.
                  </p>

                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "70px" }}>
                    <div>
                      <div style={{ fontWeight: "bold" }}>Yang menerima pelepasan</div>
                      <div style={{ marginTop: "105px", textAlign: "center" }}>
                        <span className="courier-prime-bold">{item?.legal_nominatif?.nama_2}</span>
                      </div>
                    </div>
                    <div>
                      <div style={{ textAlign: "right", fontWeight: "bold" }}>Tanda tangan yang melepaskan</div>
                      <div style={{ marginTop: "105px", textAlign: "center" }}>
                        <span className="courier-prime-bold">{item?.legal_nominatif?.nama}</span>
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "60px" }}>
                    <div>
                      <div className="courier-prime-bold">SAKSI :</div>
                      <table style={{ marginTop: "10px" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "140px", height: "80px", fontWeight: "bold" }}>1. Kepala Desa</td>
                            <td>
                              <span className="courier-prime-bold">{item?.legal_nominatif?.kepala_desa}</span>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "140px", height: "80px", fontWeight: "bold" }}>2. Sekdes</td>
                            <td>
                              <span className="courier-prime-bold">{item?.legal_nominatif?.saksi_st_1}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style={{ textAlign: "left" }}>
                      <div style={{ fontWeight: "bold" }}>MENGETAHUI</div>
                      <div style={{ fontWeight: "bold" }}>Camat Kepala Wilayah</div>
                      <div style={{ fontWeight: "bold" }}>
                        Kecamatan <span className="courier-prime-bold">{item?.legal_nominatif?.kecamatan}</span>
                      </div>
                    </div>
                  </div>
                  {/* {item.aasdfasdfasdfa && <div style={{ position: "absolute", marginTop: "-20px", width: "50px", marginLeft: "20%", textAlign: "center" }}><img width={70} alt="" src={base64Svg} /></div>} */}
                </td>
              </tr>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
